import React, { Component } from 'react';
import './TeamHeaderRow.css';

class TeamHeaderRow extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <tr>
                <th className="clickable player" onClick={(e) => this.props.changeSortOrder("name")}>Player</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("min")}>MIN</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("fgm")}>FGM</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("fga")}>FGA</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("fgp")}>FG%</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("tpm")}>3PM</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("tpa")}>3PA</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("tpp")}>3P%</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("ftm")}>FTM</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("fta")}>FTA</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("ftp")}>FT%</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("offReb")}>OREB</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("defReb")}>DREB</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("totReb")}>REB</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("assists")}>AST</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("turnovers")}>TO</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("steals")}>STL</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("blocks")}>BLK</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("pFouls")}>PF</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("points")}>PTS</th>
                <th className="clickable" onClick={(e) => this.props.changeSortOrder("plusMinus")}>+/-</th>
            </tr>
        );
    }
}

export default TeamHeaderRow;